export const extractCriticalCSS = () => {
  // 关键CSS规则 - 根据实际项目调整
  return `
    /* 首屏关键样式 */
    html, body {
      margin: 0;
      padding: 0;
      font-family: 'Manrope', sans-serif;
    }
    #app {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }
    .header, .footer {
      flex-shrink: 0;
    }
    .main-content {
      flex-grow: 1;
    }
    /* 其他关键样式... */
  `;
};

export const loadNonCriticalCSS = () => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/css/non-critical.css';
  link.media = 'print';
  link.onload = () => {
    link.media = 'all';
  };
  document.head.appendChild(link);
};
